import * as Reach from '@reach/menu-button';
import styled from 'styled-components';

import TestnetIcon from '#/assets/TestnetIcon';
import MainnetIcon from '#/assets/MainnetIcon';

import { cFFFFFF } from '#/colors';

import {
  type ChainEnvId,
  useChainEnvsView,
} from '#/features/chain-envs/chain-envs-context';

import { NavItemPopoverButton, PopoverMenu } from './PopoverMenu';

export default function EnvironmentMenu() {
  const envsView = useChainEnvsView();

  return (
    <Reach.Menu>
      <Reach.MenuButton
        as={StyledNavItemPopoverButton}
        aria-label={`${envsView.current.name} Environment`}
      >
        {ID_ICON_MAP[envsView.current.id]}
      </Reach.MenuButton>

      <Reach.MenuList as={StyledPopoverMenu}>
        {envsView.options.map((env) => (
          <Reach.MenuLink
            key={env.id}
            href={env.url}
            disabled={env.id === envsView.current.id}
          >
            {ID_ICON_MAP[env.id]} {env.name}
          </Reach.MenuLink>
        ))}
      </Reach.MenuList>
    </Reach.Menu>
  );
}

const ID_ICON_MAP: Record<ChainEnvId, React.ReactNode> = {
  mainnet: <MainnetIcon />,
  testnet: <TestnetIcon />,
};

const StyledNavItemPopoverButton = styled(NavItemPopoverButton)`
  font-weight: 500;
`;

const StyledPopoverMenu = styled(PopoverMenu)`
  [data-reach-menu-link][aria-disabled='true'] {
    color: ${cFFFFFF};
  }
`;
